import "./propertyInfo.css";
import React, { Suspense } from "react";

import Slider from "react-slick";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useRouteMatch,
} from "react-router-dom";
import { Button, Form, FormGroup, Label, Input, FormText } from "reactstrap";
import { BsFacebook } from "react-icons/bs";
import Loading from "../../components/Loading";
import LoggedHeader from "../../DefaultLayout/LoggedHeader";
import Footer from "../../DefaultLayout/Footer";
import NavbarSection from "../../DefaultLayout/Navbar";
import DashboardNavbar from "../../DefaultLayout/DashboardNavbar.js";

const PropertyInfo = () => {
  const silderData = [
    {
      image: "assets/image8.jpg",
      address: "Gerplustræti, 270",
      description: "Apartment, 4 rooms, 74m²",
      price: "20,0000 kr.",
    },
    {
      image: "assets/image7.jpg",
      address: "Lindasmári, 201 Kóp.",
      description: "Apartment, 2 rooms, 74m²",
      price: "10,0000 kr.",
    },

    {
      image: "assets/image5.jpg",
      address: "Vesturbraut, 220 Hfj.",
      description: "Apartment, 5 rooms, 74m²",
      price: "30,0000 kr.",
    },
    {
      image: "assets/image4.jpg",
      address: "Vesturbraut, 220 Hfj.",
      description: "Apartment, 5 rooms, 74m²",
      price: "30,0000 kr.",
    },
    {
      image: "assets/image3.jpg",
      address: "Vesturbraut, 220 Hfj.",
      description: "Apartment, 5 rooms, 74m²",
      price: "30,0000 kr.",
    },
    {
      image: "assets/iamge2.jpg",
      address: "Vesturbraut, 220 Hfj.",
      description: "Apartment, 5 rooms, 74m²",
      price: "30,0000 kr.",
    },
  ];

  const settings = {
    className: "center",
    dots: false,
    swipeToSlide: true,
    focusOnSelect: true,
    centerPadding: "15px",
    slidesToShow: 4,
    arrows: false,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 3,

          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,

          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,

          initialSlide: 2,
        },
      },

      {
        breakpoint: 480,
        settings: {
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <React.Fragment>
      <Suspense fallback={<Loading />}>
        <LoggedHeader />
        {/* <NavbarSection /> */}
        <DashboardNavbar/>
      </Suspense>

      <div className="div-wrapper">
        <div className="row">
          <div className="links-main1 d-flex col-lg-12">
            <p>
              The property was listed: <span>22/08/19</span>
            </p>
            <p>
              Last modified : <span>12/09/19</span>
            </p>
            <p>
              Property viewed: <span>91</span>
            </p>
            <p>
              Number of photos : <span>1</span>
            </p>
          </div>
        </div>
        <div className="row row_style">
          <div className="col-lg-8 col-md-12">
            <div className="view-port-main1">
              {/* <div className="links-main d-flex">
                    <p>
                      The property was listed: <span>22/08/19</span>
                    </p>
                    <p>
                      Last modified : <span>12/09/19</span>
                    </p>
                    <p>
                      Property viewed: <span>91</span>
                    </p>
                    <p>
                      Number of photos : <span>1</span>
                    </p>
                  </div> */}

              <div className="view-card-main1">
                <div className="img-view-main1">
                  <img src="assets/iamge2.jpg" alt="img1" />
                </div>
                <div className="overlayblack-card-info1">
                  <div className="set-overlay1 ">
                    <p>Gerplustræti, 270 Mosfellsbær</p>
                    <h6>South balcony</h6>
                  </div>
                  <div className="bottom-desc1">
                    <p>Apartment, 4 rooms, 74m2 - - - 260.000</p>
                  </div>
                </div>
                <div className="btn-all-photo1">
                  <button>All Photos</button>
                </div>
              </div>
            </div>
            <div className="set-bottom-btn-white1 d-flex">
              <div className="set-pdd-set-all1">
                <p>
                  <a>
                    <img src="assets/favourite.svg" alt="Favorites" /> Favorites
                  </a>
                </p>
              </div>
              <div className="set-pdd-set-all1">
                <p>
                  <a>
                    <img src="assets/icons/hideicon.svg" alt="Hide" /> Hide
                  </a>
                </p>
              </div>
              <div className="set-pdd-set-all1">
                <p>
                  <a>
                    <img src="assets/map222.svg" alt="Map" /> Map
                  </a>
                </p>
              </div>
              <div className="set-pdd-set-all1">
                <p>
                  <a>
                    <img src="assets/print.svg" alt="Print" /> Print
                  </a>
                </p>
              </div>
              <div className="set-pdd-set-all1">
                <p>
                  <a>
                    <img src="assets/message.svg" alt="Message" /> Message
                  </a>
                </p>
              </div>

              <div className="set-pdd-set-all1 btn-apply-property1">
                <p>
                  <a className="d-flex justify-content-center align-items-center">
                    <img src="assets/icons/applyproperty.svg" alt="Message" />{" "}
                    <span>Apply Property</span>
                  </a>
                </p>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-12">
            <div className="right-menu-bar-fill1">
              <div className="first-rent-desc">
                <div className="desc-pri-set1">
                  <p>
                    Rental price: <span>180.000</span>
                    <span>ISK / month</span>
                  </p>
                </div>
              </div>
              <div className="sec-rent-desc1">
                <div className="desc-pri-set2">
                  <p className="d-flex set-size-fn1">
                    Power: <span>7.000 &nbsp;&nbsp; Intended for</span>
                  </p>
                  <p className="d-flex set-size-fn1">
                    Hiti: <span>0 &nbsp;&nbsp; Included / housing fund</span>
                  </p>
                  <p className="d-flex set-size-fn1">
                    House fund: <span>13.000</span>
                  </p>
                </div>
              </div>
              <div className="desc-pri-set3">
                <p>
                  Total price: <span>200.000</span>
                  <span>ISK / month</span>
                </p>
              </div>

              <div className="ins-main1">
                <h2>Insurance fees</h2>
                <div className="ins-dsc1">
                  <p className="d-flex justify-content-between mb-1">
                    Bank guarantee
                    <span className="remove-gh">
                      <img src="assets/tick.svg" alt="ins" />
                      600.000
                    </span>
                  </p>
                  <p className="d-flex justify-content-between">
                    Insurance from Leiguvernd also accepted?
                    <span>Yes</span>
                  </p>
                </div>
                <button className="app-ins1">Apply for rent protection</button>
              </div>

              <div className="Landloard-main1 pt-4">
                <h2 className="mb-2">Landlord:</h2>
                <div className="land-dsc1">
                  <p className="d-flex justify-content-start">
                    <strong>Name : </strong>{" "}
                    <span className="mr-2">Björg María Oddsdóttir</span>
                  </p>
                  <p className="d-flex justify-content-start">
                    <strong>Phone : </strong> <span>8674108</span>
                  </p>
                  <p className="d-flex justify-content-start">
                    <strong>Email : </strong>{" "}
                    <span>Björg María Oddsdóttir</span>
                  </p>
                  <p className="d-flex justify-content-start">
                    <strong>Contact : </strong>{" "}
                    <span>Björg María Oddsdóttir</span>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-8 col-md-12">
            <div className="fill-list-main1">
              <div className="row">
                <div className="col-lg-4">
                  <div className="filter-all-main1">
                    <h2>Situation</h2>
                    <div className="setting-links1">
                      <p>
                        <a>
                          <span className="d-flex cus-space1">
                            <img src="assets/cross.svg" />
                            Furniture
                          </span>
                        </a>
                      </p>
                    </div>

                    <div className="setting-links1">
                      <p>
                        <a>
                          <span className="d-flex cus-space1">
                            <img src="assets/tick.svg" />
                            Bathroom: <strong> &nbsp;bath</strong>
                          </span>
                        </a>
                      </p>
                    </div>
                    <div className="setting-links1">
                      <p>
                        <a>
                          <span className="d-flex cus-space1">
                            <img src="assets/tick.svg" />
                            Laundry facilities;{" "}
                            <strong> &nbsp;in the basement</strong>
                          </span>
                        </a>
                      </p>
                    </div>
                    <div className="setting-links1">
                      <p>
                        <a>
                          <span className="d-flex cus-space1">
                            <img src="assets/cross.svg" />
                            Private entrance
                          </span>
                        </a>
                      </p>
                    </div>
                    <div className="setting-links1">
                      <p>
                        <a>
                          <span className="d-flex cus-space1">
                            <img src="assets/tick.svg" />
                            Storage
                          </span>
                        </a>
                      </p>
                    </div>
                    <div className="setting-links1">
                      <p>
                        <a>
                          <span className="d-flex cus-space1">
                            <img src="assets/cross.svg" />
                            Elevator
                          </span>
                        </a>
                      </p>
                    </div>
                    <div className="setting-links1">
                      <p>
                        <a>
                          <span className="d-flex cus-space1">
                            <img src="assets/cross.svg" />
                            Garage
                          </span>
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="filter-all-main1">
                    <h2>Home appliances</h2>
                    <div className="setting-links1">
                      <p>
                        <a>
                          <span className="d-flex cus-space1">
                            <img src="assets/tick.svg" />
                            Stove
                          </span>
                        </a>
                      </p>
                    </div>

                    <div className="setting-links1">
                      <p>
                        <a>
                          <span className="d-flex cus-space1">
                            <img src="assets/tick.svg" />
                            Refrigerator
                          </span>
                        </a>
                      </p>
                    </div>
                    <div className="setting-links1">
                      <p>
                        <a>
                          <span className="d-flex cus-space1">
                            <img src="assets/cross.svg" />
                            Dishwasher
                          </span>
                        </a>
                      </p>
                    </div>
                    <div className="setting-links1">
                      <p>
                        <a>
                          <span className="d-flex cus-space1">
                            <img src="assets/cross.svg" />
                            Washing machine
                          </span>
                        </a>
                      </p>
                    </div>
                    <div className="setting-links1">
                      <p>
                        <a>
                          <span className="d-flex cus-space1">
                            <img src="assets/cross.svg" />
                            Dryer
                          </span>
                        </a>
                      </p>
                    </div>
                    <div className="setting-links1">
                      <p>
                        <a>
                          <span className="d-flex cus-space1">
                            <img src="assets/cross.svg" />
                            Television
                          </span>
                        </a>
                      </p>
                    </div>
                    <div className="setting-links1">
                      <p>
                        <a>
                          <span className="d-flex cus-space1">
                            <img src="assets/tick.svg" />
                            Internet
                          </span>
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="filter-all-main1">
                    <h2>House rules - obligations</h2>
                    <div className="setting-links1">
                      <p>
                        <a>
                          <span className="d-flex cus-space1">
                            <img src="assets/cross.svg" />
                            Pets
                          </span>
                        </a>
                      </p>
                    </div>

                    <div className="setting-links1">
                      <p>
                        <a>
                          <span className="d-flex cus-space1">
                            <img src="assets/cross.svg" />
                            Co-tenant
                          </span>
                        </a>
                      </p>
                    </div>
                    <div className="setting-links1">
                      <p>
                        <a>
                          <span className="d-flex cus-space1">
                            <img src="assets/cross.svg" />
                            Smoking
                          </span>
                        </a>
                      </p>
                    </div>
                    <div className="setting-links1">
                      <p>
                        <a>
                          <span className="d-flex cus-space1">
                            <img src="assets/tick.svg" />
                            Both sexes
                          </span>
                        </a>
                      </p>
                    </div>

                    <div className="setting-links1">
                      <p>
                        <a>
                          <span className="d-flex cus-space1">
                            <img src="assets/cross.svg" />
                            Property for sale
                          </span>
                        </a>
                      </p>
                    </div>
                    <div className="setting-links1">
                      <p>
                        <a>
                          <span className="d-flex cus-space1">
                            <img src="assets/cross.svg" />
                            Permitted number of inhabitants
                          </span>
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-12">
            <div className="google-map-code">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15282225.79979123!2d73.7250245393691!3d20.750301298393563!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30635ff06b92b791%3A0xd78c4fa1854213a6!2sIndia!5e0!3m2!1sen!2sin!4v1587818542745!5m2!1sen!2sin"
                width="100%"
                // height="385"
                className="map-style"
                frameborder="0"
                style={{ border: 0 }}
                allowfullscreen=""
                aria-hidden="false"
                tabindex="0"
              ></iframe>
            </div>
          </div>
          <div className="col-lg-12 col-md-12">
            <div className="dsc-bottom-all1 ">
              <h2>Description :</h2>
              <p className="pt-2">
                Well organized and bright two bedroom apartment in a quiet and
                spacious house in the best location in Þingholt for rent. The
                apartment is rented with furniture and household appliances,
                incl. Washing machine in the laundry room in the basement. The
                apartment is partly covered with soot and the floor area is
                therefore considerably larger than the number of square meters
                indicates. On the hill there is a shared balcony to the south
                with a view of the pond. Tenants also have access to a shared
                sheltered garden with good evening sun.
                <br /> The entrance to the apartment is from a staircase with
                good storage space for shoes and coats. The living room is
                spacious and bright and faces west with an uninterrupted view of
                the pond and Landakotshæði. The bedroom is partly covered with a
                south-facing window facing the balcony and blackout curtains.
                The kitchen has simple kitchen furniture Dishwasher, stove and
                refrigerator. The kitchen also has a bath with hand shower and
                washbasin. From the kitchen you walk to a staircase where you go
                down to the laundry room. The stairwell has bright toilet
                facilities With good windows. The apartment is available f.o.m.
                September 1 and leased for one year with the possibility of
                extension. Rental price is 200,000 in advance + 1 month
                guarantee. Only quiet and orderly tenants come Possible but this
                is a wonderful apartment for the right person. Interested
                parties please contact Björg at 867 4108.
              </p>
            </div>
            <div className="btn-tow-bottom-side d-flex justify-content-between pt-2 pb-2">
              <Link to="/report-property">
                <button className="btn-reportspam1">
                  <span>
                    <img src="assets/report.svg" alt="report" />
                    Report here
                  </span>
                </button>
              </Link>
              <button className="btn-app-pro1">
                <span>
                  <img src="assets/applyforaproperty.svg" alt="report" />
                  Apply for a property
                </span>
              </button>
            </div>

            <div className="similar-proprty d-flex justify-content-between">
              <h2>
                <span>
                  <img src="assets/similarproperties.svg" /> Similar properties
                </span>
              </h2>
              <h2>
                <a>See more</a>
              </h2>
            </div>

            <div className="bottom-slider">
              <Slider {...settings}>
                {silderData.map(({ image, address, description, price }) => {
                  return (
                    <div className="view-card-main2 mt-2">
                      <div className="img-view-main2 ">
                        <img src={image} alt="img1" />
                      </div>
                      <div className="overlayblack-card1">
                        <div className="set-overlay2">
                          <p>{address}</p>
                          <div className="bottom-desc2 d-flex">
                            <p>{description}</p>
                            <span>{price}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </Slider>
            </div>
          </div>
        </div>
      </div>

      <Suspense fallback={<Loading />}>
        <Footer />
      </Suspense>
    </React.Fragment>
  );
};

export default PropertyInfo;
